{
  "VALIDATION_FAILED": "البيانات المرسلة غير صالحة",
  "PHONE_TAKEN": "رقم الهاتف مسجل لعميل آخر",
  "CUSTOMERS_UNAVAILABLE": "تعذر التحقق من الرقم لدى نظام العملاء ولم يتم الحفظ، حاول مجددا",
  "CUSTOMER_PHONE_REFUSED": "نظام العملاء رفض تعديل رقم الهاتف، لم يتم حفظ التعديل",
  "DOCUMENT_TAKEN": "الوثيقة مسجلة لعميل آخر",
  "CATEGORY_IN_USE": "هذا التصنيف مرتبط بعملاء ولا يمكن حذفه",
  "USERNAME_TAKEN": "اسم المستخدم هذا مستخدم بالفعل",
  "NO_PLATFORM_ACCESS": "ليس لديك صلاحية الوصول إلى هذا النظام",
  "UA_UNAVAILABLE": "تعذر الوصول إلى الدخول الموحد. أعد المحاولة بعد قليل.",
  "INTEGRATION_UNAUTHORIZED": "بيانات اعتماد التكامل غير صالحة",
  "UNAUTHENTICATED": "يجب تسجيل الدخول",
  "INVALID_CREDENTIALS": "البريد الإلكتروني أو كلمة المرور غير صحيحة",
  "FORBIDDEN": "ليس لديك صلاحية لتنفيذ هذا الإجراء",
  "NOT_FOUND": "العنصر المطلوب غير موجود",
  "CONFLICT": "تعارض في البيانات. أعد تحميل البيانات الحالية.",
  "UNIQUE_VIOLATION": "هذه القيمة مستخدمة بالفعل",
  "FOREIGN_KEY_VIOLATION": "هذا العنصر مرتبط بعناصر أخرى ولا يمكن حذفه",
  "RATE_LIMITED": "عدد كبير جدا من المحاولات. أعد المحاولة بعد قليل.",
  "IDEMPOTENCY_KEY_REUSED": "تم استخدام رقم هذا الطلب لعملية أخرى مسبقا",
  "REQUEST_IN_PROGRESS": "لا يزال هذا الطلب قيد المعالجة",
  "PAYLOAD_TOO_LARGE": "البيانات المرسلة تتجاوز الحجم المسموح به",
  "UNPROCESSABLE": "تعذرت معالجة الطلب. تحقق من البيانات المرسلة.",
  "INTERNAL_ERROR": "تعذر إكمال العملية. أعد المحاولة أو تواصل مع المسؤول.",
  "SERVICE_UNAVAILABLE": "الخدمة غير متاحة حاليا. أعد المحاولة بعد قليل.",
  "network": "تعذر الاتصال بالخادم. تحقق من اتصالك وأعد المحاولة.",
  "timeout": "لم نتمكن من تأكيد اكتمال العملية. تحقق من الحالة الحالية قبل إعادة المحاولة.",
  "AMOUNT_INVALID": "أدخل مبلغا أكبر من صفر",
  "AMOUNT_DECIMALS_EXCEEDED": "يسمح بخمس منازل عشرية كحد أقصى.",
  "CURRENCY_CODE_TAKEN": "رمز العملة مستخدم لعملة أخرى",
  "CURRENCY_INACTIVE": "هذه العملة غير نشطة ولا يمكن استخدامها لأمانة جديدة",
  "CURRENCY_IN_USE": "لا يمكن تغيير رمز العملة بعد استخدامها في أمانة",
  "TABLET_NOT_CONFIGURED": "خدمة التابلت غير مهيأة على الخادم. تواصل مع المسؤول.",
  "TABLET_UNAVAILABLE": "تعذر الاتصال بخدمة التابلت. حاول مرة أخرى.",
  "TABLET_NOT_AVAILABLE": "جهاز التابلت غير متاح في هذا الفرع.",
  "TABLET_BUSY": "جهاز التابلت مشغول بعملية أخرى",
  "TABLET_REQUEST_INVALID": "رفضت خدمة التابلت بيانات العملية. تحقق من البيانات المدخلة وحاول مرة أخرى.",
  "TABLET_TASK_CLOSED": "انتهت هذه الخطوة على التابلت",
  "TABLET_TASK_NOT_SUBMITTED": "لم يكمل العميل البيانات على التابلت بعد",
  "TABLET_TASK_KIND_MISMATCH": "الخطوة على التابلت لا تطابق هذه العملية",
  "SIGNATURE_REQUIRED": "التوقيع مطلوب",
  "FILE_TYPE_NOT_ALLOWED": "نوع الملف غير مسموح",
  "FILE_TOO_LARGE": "حجم الملف يتجاوز المسموح به",
  "DEPOSIT_NOT_DRAFT": "تم تأكيد هذه الأمانة أو حذفها مسبقا",
  "DEPOSIT_DRAFT_NOT_OWNER": "هذه المسودة لموظف آخر",
  "DEPOSIT_CUSTOMER_NOT_PRESENT": "تم اختيار العميل غير موجود لهذه الأمانة، لا يمكن الإرسال إلى التابلت",
  "DEPOSIT_REFERENCE_UNKNOWN": "الرقم المرجعي غير معروف",
  "DEPOSIT_NOT_IN_CUSTODY": "هذه الأمانة ليست في حوزتنا",
  "DEPOSIT_OTHER_BRANCH": "هذه الأمانة محفوظة في فرع آخر",
  "DEPOSIT_BRANCH_NOT_ALLOWED": "ليس لديك صلاحية على فرع هذه الأمانة",
  "DEPOSIT_REFERRAL_PENDING": "هذه الأمانة بانتظار مراجعة المشرف",
  "DEPOSIT_REFERRAL_NOT_PENDING": "تمت مراجعة هذه الإحالة مسبقا",
  "DEPOSIT_FIELD_NOT_EDITABLE": "لا يمكن تعديل هذا الحقل في حالة الأمانة الحالية",
  "DEPOSIT_NO_CHANGES": "لم تغير أي حقل",
  "MESSAGE_NOT_RESENDABLE": "لا يمكن إعادة إرسال هذه الرسالة",
  "PHONE_REQUIRED": "رقم الهاتف مطلوب",
  "PHONE_INVALID": "رقم الهاتف غير صالح",
  "PHONE_NOT_MOBILE": "رقم أرضي غير مسموح، أدخل رقم خلوي",
  "PHONE_COUNTRY_NOT_ALLOWED": "أرقام هذه الدولة غير مقبولة",
  "PHONE_VERIFICATION_REQUIRED": "يجب تأكيد رقم الهاتف قبل الحفظ",
  "PHONE_VERIFICATION_INVALID": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "PHONE_VERIFICATION_RECEIPT_EXPIRED": "انتهت صلاحية تأكيد الرقم، أعد التحقق",
  "OTP_INVALID": "الرمز غير صحيح",
  "OTP_EXPIRED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_ATTEMPTS_EXCEEDED": "تم تجاوز عدد المحاولات، اطلب رمزا جديدا",
  "OTP_RESEND_TOO_SOON": "إعادة إرسال الرمز غير متاحة الآن",
  "OTP_SEND_LIMIT": "تم إرسال عدد كبير من الرموز لهذا الرقم",
  "OTP_SEND_FAILED": "تعذر إرسال رمز التحقق عبر واتساب ولم يتم الحفظ. حاول مجددا، أو يمكن للمسؤول إيقاف تأكيد الرقم من الإعدادات",
  "OTP_ALREADY_VERIFIED": "تم تأكيد رقم الهاتف",
  "OTP_ALREADY_CONSUMED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_BINDING_MISMATCH": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "OTP_NOT_VERIFIED": "يجب تأكيد رقم الهاتف قبل الحفظ",
  "OTP_CONSUME_WINDOW_PASSED": "انتهت صلاحية الرمز، اطلب رمزا جديدا",
  "IDEMPOTENCY_CONFLICT": "تم استخدام رقم هذا الطلب لعملية أخرى مسبقا",
  "PHONE_TAKEN_BY": "رقم الهاتف مسجل لعميل آخر: {{name}}"
}
